import { Tab, Tabs, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Tag } from 'components/atoms/Text'

const HeaderTabs = ({
  activePage,
  tabs,
  handleChange,
  handleMouseEnter,
  handleMouseLeave
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <Tabs
      value={activePage}
      onChange={handleChange}
      sx={{
        '& .MuiTabs-flexContainer': {
          gap: 8,
          '@media (min-width:1024px)': {
            gap: 16
          },
          '@media (min-width:1440px)': {
            gap: 20
          }
        },
        '& .MuiTabs-indicator': {
          display: 'none'
        },
        '& .Mui-selected': {
          padding: '12px 0',
          borderBottom: `3px solid ${theme.palette.primary.main}`
        }
      }}>
      {tabs.map(tab => {
        let label = t(`headers.${tab.label}`)
        if (tab.value === activePage) {
          label = <strong>{label}</strong>
        }
        return (
          <Tab
            sx={{
              padding: '10px 0px 12px 0px',
              fontWeight: 400,
              fontSize: 15,
              minWidth: 'auto',
              color: theme.palette.primary.main,
              '@media (min-width:1024px)': {
                fontSize: 16
              }
            }}
            value={tab.value}
            label={
              <>
                {label}
                {tab.tag && (
                  <Tag
                    sx={{
                      backgroundColor: theme.palette.secondary.main,
                      padding: '2px 3px',
                      marginLeft: 2,
                      fontSize: 11,
                      letterSpacing: 0.44
                    }}>
                    {t(`headers.tags.${tab.tag}`)}
                  </Tag>
                )}
              </>
            }
            key={tab.value}
            onMouseEnter={e =>
              handleMouseEnter ? handleMouseEnter(e, tab.value) : undefined
            }
            onMouseLeave={e =>
              handleMouseLeave ? handleMouseLeave(e) : undefined
            }
            iconPosition='start'
            onClick={e =>
              tab.value === activePage ? handleChange(e, tab.value) : null
            }
          />
        )
      })}
    </Tabs>
  )
}

export default HeaderTabs
